import { Plus, Trash } from "@phosphor-icons/react";

export function ExtraLinksEditor({ links, onChange, testIdPrefix }) {
    const add = () => onChange([...links, { id: crypto.randomUUID(), label: "", url: "" }]);
    const update = (id, field, value) => onChange(links.map((l) => (l.id === id ? { ...l, [field]: value } : l)));
    const remove = (id) => onChange(links.filter((l) => l.id !== id));

    return (
        <div data-testid={`${testIdPrefix}-editor`}>
            <div className="flex items-center justify-between">
                <label className="text-xs text-muted-foreground">Tautan Google Drive Tambahan</label>
                <button
                    type="button"
                    onClick={add}
                    data-testid={`${testIdPrefix}-add`}
                    className="text-primary text-xs flex items-center gap-1 hover:underline"
                >
                    <Plus size={12} weight="bold" /> Tambah Link
                </button>
            </div>
            {links.map((l) => (
                <div key={l.id} className="mt-2 flex gap-2 items-center">
                    <input
                        value={l.label}
                        onChange={(e) => update(l.id, "label", e.target.value)}
                        placeholder="Label (misal: Shop Drawing)"
                        className="flex-1 min-w-0 border border-border px-3 py-2 text-sm outline-none focus:border-primary transition-colors bg-transparent"
                        data-testid={`${testIdPrefix}-label-${l.id}`}
                    />
                    <input
                        value={l.url}
                        onChange={(e) => update(l.id, "url", e.target.value)}
                        placeholder="https://drive.google.com/..."
                        className="flex-1 min-w-0 border border-border px-3 py-2 text-sm outline-none focus:border-primary transition-colors bg-transparent"
                        data-testid={`${testIdPrefix}-url-${l.id}`}
                    />
                    <button
                        type="button"
                        onClick={() => remove(l.id)}
                        data-testid={`${testIdPrefix}-remove-${l.id}`}
                        className="text-muted-foreground hover:text-destructive transition-colors shrink-0"
                        title="Hapus link"
                    >
                        <Trash size={16} weight="light" />
                    </button>
                </div>
            ))}
        </div>
    );
}
